import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type CareEventValidationAction = 'convert' | 'dismiss';

export interface CareEventValidationItem {
  key: string;
  name: string;
  isBcEligible: boolean | null;
  benefitCheckReason?: string | null;
  billingCodeOptions?: string[];
  canConvert?: boolean;
}

export interface CareEventValidationSnackbarData {
  title: string;
  message?: string;
  canConvert?: boolean;
  items?: CareEventValidationItem[];
}

@Component({
  selector: 'app-care-event-validation-snackbar',
  templateUrl: './care-event-validation-snackbar.component.html',
  styleUrls: ['./care-event-validation-snackbar.component.scss'],
})
export class CareEventValidationSnackbarComponent {
  action = new EventEmitter<{ action: CareEventValidationAction; item?: CareEventValidationItem }>();

  constructor(
    private snackBarRef: MatSnackBarRef<CareEventValidationSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: CareEventValidationSnackbarData
  ) {}

  convert(item?: CareEventValidationItem): void {
    this.action.emit({ action: 'convert', item });
    this.snackBarRef.dismiss();
  }

  dismiss(): void {
    this.action.emit({ action: 'dismiss' });
    this.snackBarRef.dismiss();
  }
}
